import React, { useRef, useEffect, useState } from 'react'
import _ from 'lodash'
import './imageSlider.css'
import { joinPaths } from 'src/common/razzle-platform-components/utils'
import { BASE_URL } from 'src/common/razzle-platform-map/configs'

export default function ImageSlider({ item, defaultImg }) {
    const [moveX, setMoveX] = useState(0)

    const handleClick = ({ event, direction, idx }) => {
        event.preventDefault()
        const lastImageIndex = item.images.length - 1
        let newMoveX
        if (direction === 'left') {
            newMoveX = moveX === 0 ? lastImageIndex : moveX - 1
        } else if (direction === 'right') {
            newMoveX = moveX === lastImageIndex ? 0 : moveX + 1
        } else {
            newMoveX = idx
        }
        setMoveX(newMoveX)
    }

    return (
        <div className="slider-container">
            <div className="gallery" style={{ transform: `translateX(-${moveX * 100}%)` }}>
                {item.images?.length ? (
                    _.sortBy(item.images, [image => image.type]).map((img) => (
                        <div key={img.id} className="mySlide">
                            <img src={joinPaths(BASE_URL, img.name['500x500'])} alt={item.name} loading="lazy" />
                        </div>
                    ))
                ) : (
                    <div className="mySlide">
                        <img src={defaultImg || '/images/item_background_for_map.png'} alt={item.name} loading="lazy" />
                    </div>
                )}
            </div>
            {item.images.length > 1 && (
                <>
                    <button className="button-left" onClick={(event) => handleClick({ event, direction: 'left' })}>
                        <span>&#10094;</span>
                    </button>
                    <button className="button-right" onClick={(event) => handleClick({ event, direction: 'right' })}>
                        <span>&#10095;</span>
                    </button>
                    <div className="dots">
                        <div onClick={(e) => e.preventDefault()}>
                            {item.images.map((img, idx) => (
                                <div
                                    key={img.id}
                                    className={`dot ${idx === moveX ? 'active' : ''}`}
                                    onClick={(event) => handleClick({ event, direction: 'random', idx })}
                                ></div>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}
